import { SEARCH_INTENTS_TR } from "./aiKnowledge.js";

export type ServiceLinkLocale = "tr";

export type ServiceLinkPhrase = {
  phrase: string;
  href: string;
  priority: number;
  locale: ServiceLinkLocale;
};

export type TagServicePillar = {
  label: string;
  href: string;
  description: string;
};

/** site.ts modTabs + feature başlıkları ile senkron — api katmanında @/ import yok */
const MOD_LINK_DATA: { label: string; href: string; features: { title: string; href: string }[] }[] = [
  {
    label: "E-Ticaret",
    href: "/tr/servisler/e-ticaret",
    features: [
      { title: "Sipariş & Kargo Yönetimi", href: "/tr/servisler/e-ticaret/siparis-ve-kargo-yonetimi" },
      { title: "Ürün & Varyant Yönetimi", href: "/tr/servisler/e-ticaret/urun-ve-varyant-yonetimi" },
      { title: "Envanter Takibi", href: "/tr/servisler/e-ticaret/envanter-takibi" },
      { title: "Pazaryeri Entegrasyonları", href: "/tr/servisler/e-ticaret/pazaryeri-entegrasyonlari" },
      { title: "Enabase Online Mağaza", href: "/tr/servisler/e-ticaret/enabase-online-magaza" },
      { title: "Ödeme & Tahsilat", href: "/tr/servisler/e-ticaret/odeme-ve-tahsilat" },
    ],
  },
  {
    label: "Hızlı Satış",
    href: "/tr/servisler/hizli-satis",
    features: [
      { title: "Müşteri Analizi", href: "/tr/servisler/hizli-satis/musteri-analizi" },
      { title: "Parçalı Ödeme", href: "/tr/servisler/hizli-satis/parcali-odeme" },
      { title: "Barkod Okuyucu", href: "/tr/servisler/hizli-satis/barkod-okuyucu" },
      { title: "Vade Kontrolü", href: "/tr/servisler/hizli-satis/vade-kontrolu" },
      { title: "Anlık Stok Düşümü", href: "/tr/servisler/hizli-satis/anlik-stok-dusumu" },
      { title: "Fiş & Tahsilat", href: "/tr/servisler/hizli-satis/fis-ve-tahsilat" },
    ],
  },
  {
    label: "Bayi & Toptan",
    href: "/tr/servisler/bayi-toptan",
    features: [
      { title: "Bayi Fiyat Tanımlamaları", href: "/tr/servisler/bayi-toptan/bayi-fiyat-tanimlamalari" },
      { title: "Müşteri Grubu Bazlı Fiyatlar", href: "/tr/servisler/bayi-toptan/musteri-grubu-bazli-fiyatlar" },
      { title: "Toplu Sipariş Yönetimi", href: "/tr/servisler/bayi-toptan/toplu-siparis-yonetimi" },
      { title: "Kurumsal Müşteri Portalı", href: "/tr/servisler/bayi-toptan/kurumsal-musteri-portali" },
      { title: "Teklif & Onay Süreci", href: "/tr/servisler/bayi-toptan/teklif-ve-onay-sureci" },
      { title: "Özel Ödeme Vadesi", href: "/tr/servisler/bayi-toptan/ozel-odeme-vadesi" },
    ],
  },
  {
    label: "Ön Muhasebe",
    href: "/tr/servisler/on-muhasebe",
    features: [
      { title: "E-Fatura & E-Arşiv", href: "/tr/servisler/on-muhasebe/e-fatura-ve-e-arsiv" },
      { title: "Çek & Senet Takibi", href: "/tr/servisler/on-muhasebe/cek-ve-senet-takibi" },
      { title: "Kasa & Banka Yönetimi", href: "/tr/servisler/on-muhasebe/kasa-ve-banka-yonetimi" },
      { title: "Cari Hesap Yönetimi", href: "/tr/servisler/on-muhasebe/cari-hesap-yonetimi" },
      { title: "Belgeler", href: "/tr/servisler/on-muhasebe/belgeler" },
      { title: "Gelir / Gider Analizi", href: "/tr/servisler/on-muhasebe/gelir-gider-analizi" },
      { title: "Mali Raporlar", href: "/tr/servisler/on-muhasebe/mali-raporlar" },
    ],
  },
  {
    label: "Web Site",
    href: "/tr/servisler/web-site",
    features: [
      { title: "Sürükle & Bırak Editör", href: "/tr/servisler/web-site/surukle-ve-birak-editor" },
      { title: "Blog Yönetimi", href: "/tr/servisler/web-site/blog-yonetimi" },
      { title: "Kategori & Filtreler", href: "/tr/servisler/web-site/kategori-ve-filtreler" },
      { title: "Mobil Uyumlu Tasarım", href: "/tr/servisler/web-site/mobil-uyumlu-tasarim" },
      { title: "SEO Araçları", href: "/tr/servisler/web-site/seo-araclari" },
      { title: "Özel Alan Adı Desteği", href: "/tr/servisler/web-site/ozel-alan-adi-destegi" },
    ],
  },
];

const FEAT_LINK_DATA: { title: string; href: string; subs?: { title: string; href: string }[] }[] = [
  {
    title: "Ön Muhasebe",
    href: "/tr/servisler/on-muhasebe",
    subs: [
      { title: "Gelir & Gider Takibi", href: "/tr/servisler/on-muhasebe/gelir-gider-analizi" },
      { title: "Cari Hesap Yönetimi", href: "/tr/servisler/on-muhasebe/cari-hesap-yonetimi" },
    ],
  },
  {
    title: "E-Fatura & E-Arşiv",
    href: "/tr/servisler/on-muhasebe/e-fatura-ve-e-arsiv",
    subs: [
      { title: "Otomatik Fatura Gönderimi", href: "/tr/servisler/on-muhasebe/e-fatura-ve-e-arsiv" },
      { title: "Siparişten Otomatik Fatura", href: "/tr/servisler/on-muhasebe/e-fatura-ve-e-arsiv" },
    ],
  },
  {
    title: "E-Ticaret Yönetimi",
    href: "/tr/servisler/e-ticaret",
    subs: [
      { title: "Pazaryeri Entegrasyonu", href: "/tr/servisler/e-ticaret/pazaryeri-entegrasyonlari" },
      { title: "Sipariş Otomasyonu", href: "/tr/servisler/e-ticaret/siparis-ve-kargo-yonetimi" },
    ],
  },
  {
    title: "Stok Takibi",
    href: "/tr/servisler/e-ticaret/envanter-takibi",
    subs: [{ title: "Anlık Stok Bildirimleri", href: "/tr/servisler/e-ticaret/envanter-takibi" }],
  },
  {
    title: "Raporlama & Analiz",
    href: "/tr/servisler/on-muhasebe/mali-raporlar",
    subs: [
      { title: "Detaylı Grafikler", href: "/tr/servisler/on-muhasebe/mali-raporlar" },
      { title: "Özel Rapor Oluşturma", href: "/tr/servisler/on-muhasebe/mali-raporlar" },
    ],
  },
  {
    title: "Müşteri Yönetimi",
    href: "/tr/servisler/on-muhasebe/cari-hesap-yonetimi",
    subs: [
      { title: "Müşteri Geçmişi", href: "/tr/servisler/hizli-satis/musteri-analizi" },
      { title: "Satış Süreci Takibi", href: "/tr/servisler/bayi-toptan/teklif-ve-onay-sureci" },
    ],
  },
];

/** Alt konu başlıkları için doğal dil alias'ları — tam eşleşme gerekmez */
const FEATURE_ALIASES: Record<string, string[]> = {
  "/tr/servisler/e-ticaret/siparis-ve-kargo-yonetimi": [
    "sipariş yönetimi",
    "kargo yönetimi",
    "sipariş takibi",
    "kargo takibi",
    "sipariş ve kargo",
  ],
  "/tr/servisler/e-ticaret/urun-ve-varyant-yonetimi": [
    "ürün yönetimi",
    "varyant yönetimi",
    "ürün kataloğu",
    "ürün ve varyant",
  ],
  "/tr/servisler/e-ticaret/envanter-takibi": [
    "stok takibi",
    "envanter yönetimi",
    "stok yönetimi",
    "envanter kontrolü",
  ],
  "/tr/servisler/e-ticaret/pazaryeri-entegrasyonlari": [
    "pazaryeri entegrasyonu",
    "pazaryeri entegrasyonları",
    "marketplace entegrasyonu",
    "pazaryeri bağlantısı",
  ],
  "/tr/servisler/e-ticaret/enabase-online-magaza": [
    "online mağaza",
    "e-ticaret sitesi",
    "dijital mağaza",
    "enabase online",
  ],
  "/tr/servisler/e-ticaret/odeme-ve-tahsilat": [
    "online ödeme",
    "sanal pos",
    "tahsilat yönetimi",
    "ödeme entegrasyonu",
  ],
  "/tr/servisler/hizli-satis/musteri-analizi": [
    "müşteri geçmişi",
    "satın alma geçmişi",
    "müşteri profili",
  ],
  "/tr/servisler/hizli-satis/parcali-odeme": [
    "taksitli ödeme",
    "çoklu ödeme",
    "parçalı tahsilat",
  ],
  "/tr/servisler/hizli-satis/barkod-okuyucu": [
    "barkod okutma",
    "barkod ile satış",
    "barkod tarama",
  ],
  "/tr/servisler/hizli-satis/vade-kontrolu": [
    "vadesi geçmiş borç",
    "vade takibi",
    "kredi vadesi",
  ],
  "/tr/servisler/hizli-satis/anlik-stok-dusumu": [
    "anlık stok güncelleme",
    "otomatik stok düşümü",
    "stok düşümü",
  ],
  "/tr/servisler/hizli-satis/fis-ve-tahsilat": [
    "satış fişi",
    "perakende fiş",
    "kasa fişi",
    "fiş ve tahsilat",
  ],
  "/tr/servisler/bayi-toptan/bayi-fiyat-tanimlamalari": [
    "bayi fiyatları",
    "toptan fiyat",
    "bayi fiyat listesi",
  ],
  "/tr/servisler/bayi-toptan/musteri-grubu-bazli-fiyatlar": [
    "grup fiyatları",
    "müşteri grubu fiyat",
    "grup bazlı fiyat",
  ],
  "/tr/servisler/bayi-toptan/toplu-siparis-yonetimi": [
    "toplu sipariş",
    "b2b sipariş",
    "toplu sipariş takibi",
  ],
  "/tr/servisler/bayi-toptan/kurumsal-musteri-portali": [
    "bayi portalı",
    "b2b portal",
    "kurumsal portal",
    "bayi sipariş portalı",
  ],
  "/tr/servisler/bayi-toptan/teklif-ve-onay-sureci": [
    "teklif süreci",
    "fiyat onayı",
    "teklif onay",
    "teklif takibi",
    "teklif takip",
    "teklif yazılımı",
    "satış teklifi",
    "teklif pdf",
    "teklif mail",
    "tekliften siparişe",
    "teklif yönetimi",
    "b2b teklif",
  ],
  "/tr/servisler/bayi-toptan/ozel-odeme-vadesi": [
    "ödeme vadesi",
    "vade tanımı",
    "özel vade",
  ],
  "/tr/servisler/on-muhasebe/e-fatura-ve-e-arsiv": [
    "e-fatura",
    "e-arşiv",
    "e arşiv",
    "elektronik fatura",
    "e arşiv fatura",
  ],
  "/tr/servisler/on-muhasebe/cek-ve-senet-takibi": [
    "çek senet takibi",
    "senet takibi",
    "çek takibi",
    "çek ve senet",
  ],
  "/tr/servisler/on-muhasebe/kasa-ve-banka-yonetimi": [
    "kasa banka yönetimi",
    "nakit yönetimi",
    "kasa ve banka",
    "banka hesabı takibi",
  ],
  "/tr/servisler/on-muhasebe/cari-hesap-yonetimi": [
    "cari hesap",
    "cari hesap takibi",
    "cari yönetimi",
    "cari takip",
  ],
  "/tr/servisler/on-muhasebe/belgeler": [
    "belge yönetimi",
    "evrak arşivi",
    "dijital belge",
  ],
  "/tr/servisler/on-muhasebe/gelir-gider-analizi": [
    "gelir gider takibi",
    "gelir gider analizi",
    "gelir ve gider",
    "gider analizi",
  ],
  "/tr/servisler/on-muhasebe/mali-raporlar": [
    "finansal raporlar",
    "muhasebe raporları",
    "mali rapor",
  ],
  "/tr/servisler/web-site/surukle-ve-birak-editor": [
    "sürükle bırak",
    "sürükle ve bırak",
    "görsel editör",
    "sayfa editörü",
  ],
  "/tr/servisler/web-site/blog-yonetimi": [
    "blog modülü",
    "içerik yönetimi",
    "blog içerik",
  ],
  "/tr/servisler/web-site/kategori-ve-filtreler": [
    "ürün filtreleri",
    "kategori yönetimi",
    "filtre yönetimi",
  ],
  "/tr/servisler/web-site/mobil-uyumlu-tasarim": [
    "responsive tasarım",
    "mobil uyum",
    "mobil uyumlu site",
  ],
  "/tr/servisler/web-site/seo-araclari": [
    "seo optimizasyonu",
    "arama motoru optimizasyonu",
    "seo yönetimi",
  ],
  "/tr/servisler/web-site/ozel-alan-adi-destegi": [
    "özel alan adı",
    "özel domain",
    "kendi alan adı",
    "domain desteği",
  ],
};

const MOD_ALIASES: Record<string, string[]> = {
  "/tr/servisler/e-ticaret": ["e-ticaret yönetimi", "e ticaret modülü"],
  "/tr/servisler/hizli-satis": ["hızlı satış", "hizli satis", "pos ekranı", "kasa ekranı"],
  "/tr/servisler/bayi-toptan": ["bayi toptan", "toptan satış", "bayi ağı"],
  "/tr/servisler/on-muhasebe": ["ön muhasebe", "on muhasebe", "finans modülü"],
  "/tr/servisler/web-site": ["web sitesi modülü", "site yönetimi"],
};

/** &, / ve "ve" ile birleşik başlıklardan alt ifadeler üretir (tek kelime spam önlenir) */
function isStrongSegment(phrase: string): boolean {
  const tokens = phrase.split(/\s+/).filter(Boolean);
  if (tokens.length >= 2) return true;
  if (/^e-/i.test(phrase)) return true;
  return phrase.length >= 10;
}

function expandCompoundTitle(title: string): string[] {
  const normalized = title.replace(/\s+/g, " ").trim();
  if (!/[&/]|\sve\s/i.test(normalized)) return [];

  const parts = normalized
    .split(/\s*[&/]\s*|\s+ve\s+/i)
    .map((part) => part.trim())
    .filter((part) => part.length >= 4);
  if (parts.length < 2) return [];

  const out = new Set<string>();
  const last = parts[parts.length - 1]!;
  const lastTokens = last.split(/\s+/);

  if (lastTokens.length >= 2) {
    const suffix = lastTokens.slice(-1).join(" ");
    for (let i = 0; i < parts.length - 1; i += 1) {
      const head = parts[i]!;
      if (head.split(/\s+/).length === 1) {
        out.add(`${head} ${suffix}`);
      }
    }
  }

  for (const part of parts) {
    if (isStrongSegment(part)) out.add(part);
  }

  if (parts.length === 2) {
    const combined = `${parts[0]} ${parts[1]}`;
    if (isStrongSegment(combined)) out.add(combined);
  }

  out.delete(normalized);
  return [...out].filter((phrase) => phrase.length >= 4);
}

const SEARCH_INTENT_HREF: Record<string, string> = {
  "e-ticaret yazılımı": "/tr/servisler/e-ticaret",
  "pazaryeri entegrasyonu": "/tr/servisler/e-ticaret/pazaryeri-entegrasyonlari",
  "ön muhasebe programı": "/tr/servisler/on-muhasebe",
  "e-fatura programı": "/tr/servisler/on-muhasebe/e-fatura-ve-e-arsiv",
  "stok takip yazılımı": "/tr/servisler/e-ticaret/envanter-takibi",
  "türkiye erp kobi": "/tr/servisler/on-muhasebe",
  "online mağaza altyapısı": "/tr/servisler/e-ticaret/enabase-online-magaza",
  "trendyol stok entegrasyonu": "/tr/servisler/e-ticaret/pazaryeri-entegrasyonlari",
  "hepsiburada sipariş yönetimi": "/tr/servisler/e-ticaret/siparis-ve-kargo-yonetimi",
  "bayi sipariş portalı": "/tr/servisler/bayi-toptan/kurumsal-musteri-portali",
  "mağaza kasa yazılımı": "/tr/servisler/hizli-satis",
};

/** Etiket slug → pillar servis bandı */
export const TAG_SERVICE_PILLARS: Record<string, TagServicePillar> = {
  "on-muhasebe-programi": {
    label: "Ön Muhasebe",
    href: "/tr/servisler/on-muhasebe",
    description: "Cari, kasa-banka, e-fatura ve mali raporları tek panelde yönetin.",
  },
  "on-muhasebe-nedir": {
    label: "Ön Muhasebe",
    href: "/tr/servisler/on-muhasebe",
    description: "KOBİ'ler için cari, fatura ve stok süreçlerini dijitalleştirin.",
  },
  "e-ticaret-yazilimi": {
    label: "E-Ticaret",
    href: "/tr/servisler/e-ticaret",
    description: "Pazaryeri, online mağaza ve sipariş yönetimini birleştirin.",
  },
  "pazaryeri-entegrasyonu": {
    label: "Pazaryeri Entegrasyonları",
    href: "/tr/servisler/e-ticaret/pazaryeri-entegrasyonlari",
    description: "Trendyol, Hepsiburada, n11 ve daha fazlası ile stok senkronu.",
  },
  "e-fatura-programi": {
    label: "E-Fatura & E-Arşiv",
    href: "/tr/servisler/on-muhasebe/e-fatura-ve-e-arsiv",
    description: "e-Fatura ve e-Arşiv belgelerini entegratörle gönderin.",
  },
  "stok-takip-yazilimi": {
    label: "Envanter Takibi",
    href: "/tr/servisler/e-ticaret/envanter-takibi",
    description: "Stok hareketlerini anlık izleyin, kritik seviye uyarıları alın.",
  },
  "online-magaza-altapisi": {
    label: "Enabase Online Mağaza",
    href: "/tr/servisler/e-ticaret/enabase-online-magaza",
    description: "Kendi alan adınızda SEO odaklı online mağaza kurun.",
  },
};

function addPhrase(
  map: Map<string, ServiceLinkPhrase>,
  phrase: string,
  href: string,
  priority: number
) {
  const trimmed = phrase.trim();
  if (!trimmed || trimmed.length < 4) return;
  const key = trimmed.toLowerCase();
  const existing = map.get(key);
  if (existing && existing.priority >= priority) return;
  map.set(key, { phrase: trimmed, href, priority, locale: "tr" });
}

function buildPhraseMap(): Map<string, ServiceLinkPhrase> {
  const map = new Map<string, ServiceLinkPhrase>();

  for (const mod of MOD_LINK_DATA) {
    addPhrase(map, mod.label, mod.href, 50);
    for (const alias of MOD_ALIASES[mod.href] ?? []) {
      addPhrase(map, alias, mod.href, 55);
    }
    for (const feature of mod.features) {
      addPhrase(map, feature.title, feature.href, 80);
      for (const segment of expandCompoundTitle(feature.title)) {
        addPhrase(map, segment, feature.href, 78);
      }
      for (const alias of FEATURE_ALIASES[feature.href] ?? []) {
        addPhrase(map, alias, feature.href, 85);
      }
    }
  }

  for (const feat of FEAT_LINK_DATA) {
    addPhrase(map, feat.title, feat.href, 70);
    for (const sub of feat.subs ?? []) {
      addPhrase(map, sub.title, sub.href, 75);
    }
  }

  for (const intent of SEARCH_INTENTS_TR) {
    const href = SEARCH_INTENT_HREF[intent];
    if (href) addPhrase(map, intent, href, 90);
  }

  return map;
}

let cachedPhrases: ServiceLinkPhrase[] | null = null;

export function getServiceLinkPhrases(locale: ServiceLinkLocale = "tr"): ServiceLinkPhrase[] {
  if (locale !== "tr") return [];
  if (!cachedPhrases) {
    cachedPhrases = [...buildPhraseMap().values()].sort(
      (a, b) => b.phrase.length - a.phrase.length || b.priority - a.priority
    );
  }
  return cachedPhrases;
}

export function getTagServicePillar(tagSlug: string): TagServicePillar | null {
  return TAG_SERVICE_PILLARS[tagSlug] ?? null;
}

export function getContentLinksForAi(limit = 40): { phrase: string; href: string }[] {
  return getServiceLinkPhrases("tr")
    .slice(0, limit)
    .map(({ phrase, href }) => ({ phrase, href }));
}
